/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataNotificationFilter } from './businessObjectDataNotificationFilter';
import { JobAction } from './jobAction';


/**
 * The request to update a business object data notification registration
 */
export interface BusinessObjectDataNotificationRegistrationUpdateRequest { 
    /**
     * The type of business object data event in which this notification should trigger
     */
    businessObjectDataEventType: string;
    businessObjectDataNotificationFilter: BusinessObjectDataNotificationFilter;
    /**
     * The list of jobs to execute when this notification is triggered
     */
    jobActions?: Array<JobAction>;
    /**
     * The status of the notification registration
     */
    notificationRegistrationStatus: string;
}
